import { render } from "./TrialBalance.vue?vue&type=template&id=06cc901d&scoped=true"
import script from "./TrialBalance.vue?vue&type=script&lang=js"
export * from "./TrialBalance.vue?vue&type=script&lang=js"

import "./TrialBalance.vue?vue&type=style&index=0&id=06cc901d&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cc901d"]])

export default __exports__